import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  MdApartment,
  MdCampaign,
  MdEventAvailable,
  MdGroup,
  MdHome,
  MdLock,
  MdPayments,
  MdRateReview,
  MdSettings,
  MdSecurity,
  MdStorefront,
} from "react-icons/md";

import Overview from "views/admin/overview";
import Users from "views/admin/users";
import Vendors from "views/admin/vendors";
import Properties from "views/admin/properties";
import Bookings from "views/admin/bookings";
import Transactions from "views/admin/transactions";
import Reviews from "views/admin/reviews";
import Settings from "views/admin/settings";
import Notifications from "views/admin/notifications";
import Security from "views/admin/security";
import SignIn from "views/auth/signIn";

const routes = [
  {
    name: "Overview",
    layout: "/admin",
    path: "/overview",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: Overview,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "/users",
    icon: <Icon as={MdGroup} width="20px" height="20px" color="inherit" />,
    component: Users,
  },
  {
    name: "Vendors",
    layout: "/admin",
    path: "/vendors",
    icon: <Icon as={MdStorefront} width="20px" height="20px" color="inherit" />,
    component: Vendors,
  },
  {
    name: "Properties",
    layout: "/admin",
    path: "/properties",
    icon: <Icon as={MdApartment} width="20px" height="20px" color="inherit" />,
    component: Properties,
  },
  {
    name: "Bookings",
    layout: "/admin",
    path: "/bookings",
    icon: <Icon as={MdEventAvailable} width="20px" height="20px" color="inherit" />,
    component: Bookings,
  },
  {
    name: "Transactions & Payouts",
    layout: "/admin",
    path: "/transactions",
    icon: <Icon as={MdPayments} width="20px" height="20px" color="inherit" />,
    component: Transactions,
  },
  {
    name: "Reviews",
    layout: "/admin",
    path: "/reviews",
    icon: <Icon as={MdRateReview} width="20px" height="20px" color="inherit" />,
    component: Reviews,
  },
  {
    name: "Notifications",
    layout: "/admin",
    path: "/notifications",
    icon: <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />,
    component: Notifications,
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "/settings",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: Settings,
  },
  {
    name: "Security",
    layout: "/admin",
    path: "/security",
    icon: <Icon as={MdSecurity} width="20px" height="20px" color="inherit" />,
    component: Security,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignIn,
    hideInSidebar: true,
  },
];

export default routes;
